/*************************************************************************
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { observable, action } from "mobx";

class TouchSelStore {
  @observable touchSelPageIndex;
  @observable isTouchSelectionInProgress;
  @observable showGrabbers;

  @observable selLeftX;
  @observable selLeftY;
  @observable selRightX;
  @observable selRightY;

  @observable eventOnGrabber;
  @observable shouldHideContextMenu;
  @observable enableContextMenuOnTouchDevices;
  @observable textInSelection;

  @observable touchEvent;
  @observable isThereAnySelection;
  richTextInSelection;
  textSelectionPageRange;

  timerID;

  constructor() {
    this.init();
  }

  @action
  init() {
    this.touchSelPageIndex = undefined;
    this.isTouchSelectionInProgress = false;
    this.showGrabbers = false;
    this.selLeftX = -1;
    this.selLeftY = -1;
    this.selRightX = -1;
    this.selRightY = -1;
    this.eventOnGrabber = false;
    this.shouldHideContextMenu = false;
    this.enableContextMenuOnTouchDevices = true;
    this.textInSelection = "";
    this.touchEvent = false;
    this.isThereAnySelection = false;
    this.textSelectionPageRange = { startPage: -1, endpage: -1 };
    this.timerID = 0;
    this.richTextInSelection = [];
  }

  initStore(stores) {
    if (stores) {
      this.stores = stores;
    }
  }

  @action
  setShouldEnableTouchContextMenu(flag) {
    this.enableContextMenuOnTouchDevices = flag;
  }

  @action
  hideContextMenu(flag) {
    if (this.timerID !== 0) {
      clearTimeout(this.timerID);
      this.timerID = 0;
    }
    this.shouldHideContextMenu = flag;
  }

  @action
  showContextMenuDebounced() {
    if (this.timerID !== 0) {
      clearTimeout(this.timerID);
      this.timerID = 0;
    }
    this.timerID = setTimeout(this.showContextMenu.bind(this), 300);
  }

  @action
  showContextMenu() {
    this.shouldHideContextMenu = false;
  }

  @action
  setEventOnGrabber(flag) {
    this.eventOnGrabber = flag;
  }

  @action
  setTouchSelPageIndex(pageIndex) {
    this.touchSelPageIndex = pageIndex;
  }

  @action
  setIsTouchSelectionInProgress(flag) {
    this.isTouchSelectionInProgress = flag;
  }

  @action
  setShowGrabbers(flag) {
    this.showGrabbers = flag;
  }

  @action
  setSelLeftX(leftX) {
    this.selLeftX = leftX;
  }

  @action
  setSelLeftY(leftY) {
    this.selLeftY = leftY;
  }

  @action
  setSelRightX(rightX) {
    this.selRightX = rightX;
  }

  @action
  setSelRightY(rightY) {
    this.selRightY = rightY;
  }

  @action
  setTextInSelection(text) {
    this.textInSelection = text;
  }

  @action
  setTouchEvent(value) {
    if (value !== undefined) this.touchEvent = value;
    else {
      this.touchEvent = true;
      setTimeout(() => {
        this.touchEvent = false;
      }, 1000);
    }
  }

  setTextSelectionPageRange(pageRange) {
    this.textSelectionPageRange = pageRange;
  }
  @action
  setIsThereAnySelection(value) {
    this.isThereAnySelection = value;
  }

  setRichTextInSelection(data) {
    this.richTextInSelection = data;
  }
}

export default TouchSelStore;
